import { normalizePath } from '@helsenorge/core-utils/url';
import { getFeatureToggle } from '../hn-feature-toggle';
import { hasScope } from '../hn-user';
// Filtrer undersøkelser som har en bestemt type
export const filterSurveyType = (survey, type) => {
    return survey._type === type;
};
// Filtrer undersøkelser som har en bestemt visningskomponent
export const filterByComponent = (survey, component) => {
    return survey.component === component;
};
// Filtrer undersøkelser som har en bestemt plassering på siden
export const filterByPosition = (survey, position) => {
    return survey.position === position;
};
// Filtrer undersøkelser basert på feature toggles
export const filterByFeatureToggle = (survey) => {
    if (survey.featureToggles.length === 0) {
        return true;
    }
    return survey.featureToggles.some(featureToggle => getFeatureToggle(featureToggle));
};
// Filtrer undersøkelser basert på brukerens scopes
export const filterByScope = (survey) => {
    if (survey.scopes.length === 0) {
        return true;
    }
    return survey.scopes.some(scope => hasScope(scope));
};
// Filtrer undersøkelser som skal vises på en side eller underside av en gitt sti
export const filterByShowWhenChildOf = (survey, normalizedPath) => {
    return survey.showWhenChildOf.some(path => normalizedPath.startsWith(normalizePath(path)));
};
// Filtrer undersøkelser som skal vises på en bestemt side
export const filterByShowOnSpecificPage = (survey, normalizedPath) => {
    return survey.showOnSpecificPage.some(path => normalizePath(path) === normalizedPath);
};
// Filtrer undersøkelser som skal vises på sider som inneholder en gitt sti
export const filterByShowOnPath = (survey, normalizedPath) => {
    return survey.showOnPath.some(path => normalizedPath.includes(path));
};
// Kombinerte filter for å sjekke om en undersøkelse skal vises basert på stien
export const filterByPathname = (survey, normalizedPath) => {
    return (filterByShowWhenChildOf(survey, normalizedPath) ||
        filterByShowOnSpecificPage(survey, normalizedPath) ||
        filterByShowOnPath(survey, normalizedPath));
};
